document.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll(
    '.image-block__image, .slide__image, [class*="ai-photo-gallery__image-"]'
  );
  
  images.forEach(function(img) {
    const src = img.src.replace(/&width=\d+/, '').replace(/\?width=\d+/, '');
    const fullSrc = src + (src.includes('?') ? '&' : '?') + 'width=2560';
    
    img.style.cursor = 'pointer';
    
    img.addEventListener('click', function(e) {
      e.stopPropagation();
      const lightbox = GLightbox({
        elements: [{ href: fullSrc, type: 'image' }],
        touchNavigation: true,
        loop: false,
        autoplayVideos: false,
        closeButton: true,
        keyboard: true
      });
      lightbox.open();
    });
  });
});
